import clsx from "clsx";
import { useEffect } from "react";
import { LINK_DETAILS_ANIMATE } from "./constants.tsx";

type LinkHoverAnimationProps = {
  AnimateFromLeft?: React.FunctionComponent<{}>;
  AnimateFromRight?: React.FunctionComponent<{}>;
  isActive: boolean;
  animate: LINK_DETAILS_ANIMATE | undefined;
};

const LinkHoverAnimation: React.FunctionComponent<LinkHoverAnimationProps> = ({
  AnimateFromLeft,
  AnimateFromRight,
  isActive,
  animate,
}) => {
  const commonAnimationProperties = "top-0 h-full -translate-x-32 opacity-50";
  const commonActiveAnimationProperties =
    "translate-x-0 opacity-100 transition-all duration-300 ease-in";

  useEffect(() => {
    if (isActive) {
      document.body.style.background = animate?.theme?.background
        ?.background as string;
      document.body.style.color = animate?.theme?.text
        ?.color as string;
    }
  }, [isActive]);

  return (
    <div
      className={clsx("", {
        hidden: !isActive,
      })}
    >
      {AnimateFromLeft
        ? (
          <div
            className={clsx(commonAnimationProperties, "right-0", {
              [commonActiveAnimationProperties]: isActive,
              "translate-x-32": !isActive,
            })}
          >
            <AnimateFromLeft />
          </div>
        )
        : null}
      {AnimateFromRight
        ? (
          <div
            className={clsx(commonAnimationProperties, "left-0", {
              [commonActiveAnimationProperties]: isActive,
              "-translate-x-32": !isActive,
            })}
          >
            <AnimateFromRight />
          </div>
        )
        : null}
    </div>
  );
};

export default LinkHoverAnimation;
